import { useState } from 'react'
import { useApiUrl, useCustom, useCustomMutation } from '@refinedev/core'
import { Button, Form, Input, Modal, Select, Space, Table, Tag, Typography, message } from 'antd'

const { Title, Text } = Typography

const TYPE_OPTIONS = [
	{ value: 'person', label: 'Individual' },
	{ value: 'org', label: 'Company' }
]

// Investor self-service: list / create / edit own legal entities (vehicles).
// Delete is admin-only (see routes/legal_entities.py). Backend scopes the list to the current investor.
const SettingsEntitiesPage = () => {
	const apiUrl = useApiUrl()
	const { data, isLoading, refetch } = useCustom({ url: `${apiUrl}/legal_entities`, method: 'get' })
	const { mutate, isLoading: isSaving } = useCustomMutation()
	const [form] = Form.useForm()
	const [open, setOpen] = useState(false)
	const [editing, setEditing] = useState(null) // entity being edited, or null when creating

	const rows = data?.data?.rows || []

	const openCreate = () => {
		setEditing(null)
		form.resetFields()
		form.setFieldsValue({ type: 'person' })
		setOpen(true)
	}
	const openEdit = e => {
		setEditing(e)
		form.setFieldsValue({ name: e.name, type: e.type })
		setOpen(true)
	}

	const onSubmit = values => {
		const isEdit = Boolean(editing)
		mutate(
			{
				url: isEdit ? `${apiUrl}/legal_entities/my/${editing.id}` : `${apiUrl}/legal_entities/my`,
				method: isEdit ? 'put' : 'post',
				values,
				successNotification: false,
				errorNotification: false
			},
			{
				onSuccess: () => {
					message.success(isEdit ? 'Saved' : 'Created')
					setOpen(false)
					refetch()
				},
				onError: () => message.error('Failed to save')
			}
		)
	}

	const columns = [
		{ title: 'Name', dataIndex: 'name' },
		{ title: 'Type', dataIndex: 'type', render: v => (v ? <Tag>{v}</Tag> : '—') },
		{
			title: '',
			key: 'actions',
			width: 90,
			render: (_, r) => (
				<Button size='small' onClick={() => openEdit(r)}>
					Edit
				</Button>
			)
		}
	]

	return (
		<Space direction='vertical' style={{ width: '100%' }} size='middle'>
			<Space style={{ width: '100%', justifyContent: 'space-between' }}>
				<Title level={4} style={{ margin: 0 }}>
					My Legal entities
				</Title>
				<Button type='primary' onClick={openCreate}>
					+ Add
				</Button>
			</Space>

			<Table
				rowKey='id'
				size='small'
				loading={isLoading}
				dataSource={rows}
				columns={columns}
				pagination={{ pageSize: 10 }}
				scroll={{ x: true }}
			/>
			<Text type='secondary'>Deletion is available via support/admin only.</Text>

			<Modal
				open={open}
				onCancel={() => setOpen(false)}
				onOk={() => form.submit()}
				confirmLoading={isSaving}
				title={editing ? 'Edit legal entity' : 'New legal entity'}
				destroyOnClose
			>
				<Form form={form} layout='vertical' onFinish={onSubmit}>
					<Form.Item name='name' label='Name' rules={[{ required: true }]}>
						<Input />
					</Form.Item>
					<Form.Item name='type' label='Type' rules={[{ required: true }]}>
						<Select options={TYPE_OPTIONS} />
					</Form.Item>
				</Form>
			</Modal>
		</Space>
	)
}

export default SettingsEntitiesPage
